'use strict';

/**
 * <input ice-auto-focus >
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceAutoFocus;
function iceAutoFocus($timeout, $log) {
  var logger = $log.getInstance('iceAutoFocus');

  return {
    restrict: 'A',
    link: link
  };

  function link(scope, element, attrs) {

    var timeout = $timeout(function () {
      try {
        element.focus();
      } catch (e) {
        logger.error('Error focusing element:', element, e);
      }
      element.focus();
    }, 400);

    scope.$on('$destroy', function () {
      $timeout.cancel(timeout);
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/ice-autofocus.directive.js
// module id = 142
// module chunks = 2